import { render, staticRenderFns } from "./spendComponent.vue?vue&type=template&id=de7811c6"
import script from "./spendComponent.vue?vue&type=script&lang=js"
export * from "./spendComponent.vue?vue&type=script&lang=js"
import style0 from "./spendComponent.vue?vue&type=style&index=0&id=de7811c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports